import React from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Button,
  ConditionBox,
  CustomInput,
  DatePickerFieldYm,
  CacheAutocomplete,
} from "components";
import moment from "moment";

const PlcfbListConditionBox = (props) => {
  const { onClickSearch } = props;

  return (
    <>
      <ConditionBox>
        <Formik
          initialValues={{
            setlDate: moment().add(-1, "days"),
            plcfbName: "",
            managerName: "",
            carName: "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            const { setlDate, ...rest } = values;
            setSubmitting(true);
            onClickSearch({
              ...rest,
              setlDate: moment(setlDate).format("YYYYMM"),
            });
            setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            setlDate: Yup.date().required().nullable(),
          })}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="HasTable">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <dl>
                            <dt>
                              발송월<i></i>
                              <span>
                                {errors.setlDate &&
                                  touched.setlDate &&
                                  errors.setlDate}
                              </span>
                            </dt>
                            <dd>
                              <div className="HasDate">
                                <DatePickerFieldYm
                                  name="setlDate"
                                  date={values.setlDate}
                                />
                              </div>
                            </dd>
                          </dl>
                          <dl>
                            <dt>영업소</dt>
                            <dd>
                              <CustomInput
                                name="plcfbName"
                                type="text"
                                onChange={handleChange}
                                value={values.plcfbName}
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt>차량명</dt>
                            <dd>
                              <CustomInput
                                name="carName"
                                type="text"
                                onChange={handleChange}
                                value={values.carName}
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt>소장명</dt>
                            <dd>
                              <CustomInput
                                name="managerName"
                                type="text"
                                placeholder="소장명 입력"
                                onChange={handleChange}
                                value={values.managerName}
                              />
                            </dd>
                          </dl>
                        </td>
                        <td>
                          <Button
                            type="submit"
                            className="inquire"
                            disabled={isSubmitting}
                          >
                            조회하기
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Form>
            );
          }}
        </Formik>
      </ConditionBox>
    </>
  );
};

PlcfbListConditionBox.propTypes = {};

export default PlcfbListConditionBox;
